import { Component } from '@angular/core';
import { FieldArrayType, FieldArrayTypeConfig, FormlyField } from '@ngx-formly/core';
import { NbButtonModule, NbIconModule } from '@nebular/theme';

@Component({
	selector: 'formly-nebular-array',
	template: `
		<div class="col-12">
			@for (f of field.fieldGroup; track f.id; let i = $index) {
				<div class="d-flex align-items-start">
					<div class="flex-grow-1">
						<formly-field [field]="f"></formly-field>
					</div>
					<button nbButton ghost status="danger" size="tiny" type="button" (click)="remove(i)">
						<nb-icon icon="trash"></nb-icon>
					</button>
				</div>
			}
			<button nbButton ghost status="primary" size="tiny" type="button" (click)="add()">
				<nb-icon icon="plus"></nb-icon> Add
			</button>
		</div>
	`,
	imports: [FormlyField, NbButtonModule, NbIconModule]
})
export class FormlyNebularArrayTypeComponent extends FieldArrayType<FieldArrayTypeConfig> {}
